import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppStateService } from 'src/app/core/services/app-state.service';
import { SendSmsService } from 'src/app/pages/sending-system/send-sms/send-sms.service';
import { AppConfigService } from '../services/config.service';
import { ConsoleService } from '../services/console.service';

@Injectable()
export class ServerDateTimeInterceptor implements HttpInterceptor {
  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Prevent SMS resending just for simple send

    const urlWithoutDomain = httpRequest.url.replace(
      AppConfigService.config.apiUrl,
      '',
    );
    if (
      urlWithoutDomain == '/ScheduledMessages/Create' &&
      httpRequest.method == 'POST'
    ) {
      if (SendSmsService.lastSendSmsId == SendSmsService.sendSmsId) {
        ConsoleService.info('Prevent SMS resending');
        return EMPTY;
      }
      if (SendSmsService.sendSmsId != 'empty')
        SendSmsService.lastSendSmsId = SendSmsService.sendSmsId;
    }

    return next
      .handle(httpRequest)
      .pipe(catchError((err) => throwError(() => err)))
      .pipe(
        map<HttpEvent<any>, any>((res: HttpEvent<any>) => {
          if (res instanceof HttpResponse) {
            const serverDateTime = res.headers.get('x-date');
            const newDateFromServer = new Date(serverDateTime);
            const oldDate = new Date(AppStateService.serverDateTime);

            const isNewDateGreater =
              newDateFromServer.getTime() > oldDate.getTime();

            if (serverDateTime && isNewDateGreater)
              AppStateService.serverDateTime = serverDateTime;
          }
          return res;
        }),
      );
  }
}

export const HttpServerDateTimeInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ServerDateTimeInterceptor,
    multi: true,
  },
];
